export function generateHref(storyObj, currentUrlSlug) {
  let domainSlug = "";
  let ysSlug = false;
  let pageRelatedSlug = "";
  switch (currentUrlSlug) {
    case "vaasalehti":
      domainSlug = "vaasa";
      pageRelatedSlug = currentUrlSlug;
      break;
    case "epari":
      domainSlug = "epari";
      pageRelatedSlug = currentUrlSlug;
      break;
    case "omat-tietoni":
      ysSlug = true;
      break;
    case "tallentamani-artikkelit":
      ysSlug = true;
      break;
    case "seuraamani-aiheet":
      ysSlug = true;
      break;
    case "collection":
      if (storyObj.sections[0]["domain-slug"] === "vaasa") {
        pageRelatedSlug = "vaasalehti";
      } else if (storyObj.sections[0]["domain-slug"] === "epari") {
        pageRelatedSlug = "epari";
      } else {
        domainSlug = "ilkka-pohjalainen"
       }
      break;
    default:
      domainSlug = "ilkka-pohjalainen";
  }

  function findByKey(key, value) {
    return (item, i) => item[key] === value;
  }
  let modifiedSlug = storyObj.slug;
  const firstPartStoryObjSlug = storyObj.slug.split("/");
  const firstSlug = firstPartStoryObjSlug[0]
  //const storyObjSlug = storyObj.slug.match(/\/([^\/]+)$/)[1];
  const matchResult = storyObj.slug.match(/\/([^\/]+)$/);
  const storyObjSlug = matchResult ? matchResult[1] : '';
  if (firstSlug === "vaasa-lehti") {
    modifiedSlug = `vaasalehti/${storyObjSlug}`;
  }
  const findParams = findByKey("domain-slug", domainSlug);
  const positionOfPaper = storyObj.sections.findIndex(findParams);
  const parts = storyObj.slug.lastIndexOf("/");
  const storySlug = storyObj.slug.substring(parts + 1);
  let finalUrl = "";
  if (storyObj.sections[positionOfPaper]) {
    const splitUrl = storyObj.sections[positionOfPaper]["section-url"].split("/");
    const joinUrl = splitUrl.slice(3);
    finalUrl = joinUrl.join("/");
  }
  return !ysSlug
    ? positionOfPaper !== -1
      ? storyObj.sections[positionOfPaper]
        ? pageRelatedSlug
          ? `/${pageRelatedSlug}/${finalUrl}/${storySlug}`
          : `/${finalUrl}/${storySlug}`
        : pageRelatedSlug
          ? `/${pageRelatedSlug}/${storyObj.sections[positionOfPaper].slug}/${storySlug}`
          : `/${storyObj.sections[positionOfPaper].slug}/${storySlug}`
      : pageRelatedSlug
        ? `/${pageRelatedSlug}/${storyObj.slug}`
        : `/${modifiedSlug}`
    : positionOfPaper !== -1
      ? storyObj.sections[positionOfPaper]
        ? `/${finalUrl}/${storySlug}`
        : `/${storyObj.sections[positionOfPaper].slug}/${storySlug}`
      : `/${modifiedSlug}`;
}

